<!-- Draft Survey Footer -->
<div
  class="footer"
  *ngIf="
    surveyStatus === surveyStatusObj.DRAFT &&
    surveyPayload?.channel_type !== TrafficChannel.SPECIFIC_AUDIENCE
  "
>
  <!-- Save Survey Action Buttons -->
  <div class="save">
    <button class="save-btn" [psUiDropdownToggleFor]="saveBtn">Save...</button>
    <ps-ui-dropdown #saveBtn="psUiDropdown">
      <button psUiDropdownItem (click)="save('save')">Save</button>
      <button
        psUiDropdownItem
        (click)="save('saveAndClone')"
        psUiGtagEvent
        trackOn="click"
        action="create_survey"
        category="Survey_Create"
        [params]="{ event_label: 'Save & Clone Button Clicked' }"
      >
        Save and Clone
      </button>
      <button psUiDropdownItem (click)="save('saveAndCreateNew')">
        Save and Create New
      </button>
      <ng-container *psUiConfigEnabled="'enableTemplate'">
        <button
          psUiDropdownItem
          (click)="openNewTemplateModal()"
          [disabled]="isMcPresentInFlyout && !isDraftSaved"
          [ngClass]="{
            'not-allowed-btn': isMcPresentInFlyout && !isDraftSaved
          }"
        >
          Save as New Template
        </button>
        <button
          *ngIf="surveyPayload && !!surveyPayload.template_id"
          psUiDropdownItem
          (click)="checkAndUpdateTemplate()"
          [disabled]="isMcPresentInFlyout && !isDraftSaved"
          [ngClass]="{
            'not-allowed-btn': isMcPresentInFlyout && !isDraftSaved
          }"
        >
          Update the current Template
        </button>
      </ng-container>
    </ps-ui-dropdown>
  </div>
  <!-- Survey navigation Links -->
  <div class="nesting-steps">
    <ul>
      <li
        class="pointer-cursor"
        [ngClass]="{
          active: buttonStatus === stepperButtonStatusObj.DEFINE_AUDIENCE,
          completed: buttonStatus > stepperButtonStatusObj.DEFINE_AUDIENCE
        }"
      >
        <a
          (click)="goToEditAudience()"
          psUiGtagEvent
          trackOn="click"
          action="define_audience"
          category="Audience"
          [params]="{ event_label: 'Define Audience' }"
          >Define Audience</a
        >
      </li>
      <li
        class="pointer-cursor"
        [ngClass]="{
          active: buttonStatus === stepperButtonStatusObj.FINALIZE_AND_LAUNCH,
          completed: buttonStatus > stepperButtonStatusObj.FINALIZE_AND_LAUNCH,
          'disable-nav-link': !waspBuyerCpiOverrideState
        }"
      >
        <a
          [ngClass]="{ 'disable-nav-link': !waspBuyerCpiOverrideState }"
          (click)="goToSurveyLaunch()"
          psUiGtagEvent
          trackOn="click"
          action="finalize_launch"
          category="Survey_Launch"
          [params]="{ event_label: 'Finalize & Launch' }"
          >Finalize & Launch!</a
        >
      </li>
      <li
        class="pointer-cursor"
        *ngIf="surveyPayload?.qlc?.enable"
        [ngClass]="{
          active: buttonStatus === stepperButtonStatusObj.MAP_QUOTAS,
          completed: buttonStatus > stepperButtonStatusObj.MAP_QUOTAS
        }"
      >
        <a (click)="goToMapQuotas()">MAP QUOTAS</a>
      </li>
    </ul>
  </div>
  <!-- Survey Next Action Button -->
  <div class="launch">
    <div
      class="launch"
      *ngIf="buttonStatus === stepperButtonStatusObj.DEFINE_AUDIENCE"
    >
      <button
        psUiButton
        (click)="goToSurveyLaunch()"
        [disabled]="disableLaunch || !waspBuyerCpiOverrideState"
      >
        Finalize & Launch!
        <em class="fa fa-angle-right"></em>
      </button>
    </div>
    <div
      class="launch"
      *ngIf="
        buttonStatus === stepperButtonStatusObj.FINALIZE_AND_LAUNCH &&
        surveyPayload?.qlc?.enable
      "
    >
      <button (click)="goToMapQuotas()">MAP Quota's ></button>
    </div>
    <div
      class="launch"
      *ngIf="
        (!surveyPayload?.qlc?.enable &&
          buttonStatus === stepperButtonStatusObj.FINALIZE_AND_LAUNCH) ||
        buttonStatus === stepperButtonStatusObj.MAP_QUOTAS
      "
    >
      <button [disabled]="isLimitedDraftBuyer" (click)="launchSurvey()">
        {{ liveUrlModalConfirmed ? 'Confirmed,' : '' }} Launch your Survey!
        <em class="fa fa-angle-right"></em>
      </button>
    </div>
  </div>
</div>
<!-- Live Survey Footer -->
<div
  class="footer footerSupplierEdit"
  *ngIf="surveyStatus !== surveyStatusObj.DRAFT"
>
  <div class="launch pull-right">
    <button routerLink="/dashboard/{{ surveyId }}">Cancel</button>
  </div>
  <div class="launch pull-right">
    <button (click)="editSurvey()">Save Changes</button>
  </div>
</div>

<div
  class="footer"
  *ngIf="surveyPayload?.channel_type === TrafficChannel.SPECIFIC_AUDIENCE"
>
  <div class="col-xs-12 col-sm-12 col-md-12 form-group text-center">
    <button
      class="btn btn-primary submit-btn channel_button"
      (click)="editSurvey()"
      psUiGtagEvent
      trackOn="click"
      action="launch_survey"
      category="Survey_Launch"
      [params]="{ event_label: 'Specific Audience Channel Launched' }"
    >
      Save & Launch Survey
    </button>
  </div>
</div>
